import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faEnvelope as farEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { calculateTotalDifference } from "../domain";

interface Props extends AbstractStepProps {
	isMarried: boolean;
	womanAge: number;
	wantsFirstHouse: boolean;
	maturityYears: number;
	loanAmount: number;
	realEstateValue: number;
}

export class Result extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { loanAmount, maturityYears } = this.props;

		return (
			<>
				<Card.Body className="bg-success-700 d-flex flex-column">
					<div className="text-white text-center">
						<p>
							A megadott adatok alapján <span className="text-gold">jogosult</span> lehetsz a kért{" "}
							<strong>{formatText(loanAmount, "ft")} CSOK Plusz</strong>ra!
						</p>
						<p className="font-weight-bold mb-0">
							Egy normál piaci hitelhez képest a teljes futamidő alatt legalább
							<span className="d-block text-gold m-0 font-weight-bold display-2">
								{formatText(calculateTotalDifference(maturityYears * 12, loanAmount), "ft")}
							</span>
							spórolhatsz.
						</p>
					</div>
				</Card.Body>
				<Card.Body className="text-white text-center bg-success rounded-bottom">
					<FontAwesomeIcon size="2x" icon={farEnvelope} className="text-center text-gold" />
					<p className="font-weight-bold h4 mb-4 text-left">A részleteket elküldjük e-mailben:</p>
					<List variant="gold" itemStyle="tick" className="text-left font-weight-bold mb-5">
						<List.Item>Törlesztőrészlet az 1. évben</List.Item>
						<List.Item>Törlesztőrészlet a 2. évtől </List.Item>
						<List.Item>Legfontosabb pénzügyi előnyök</List.Item>
						<List.Item>Igénybevételnek feltételei</List.Item>
					</List>
					<Button type="submit" variant="gold" block>
						Kérem a részletek megküldését
					</Button>
					<small className="text-white mb-0">
						A kalkulátor nem vizsgálja az összes elvárt jogosultsági feltételt.
					</small>
				</Card.Body>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
